export const expansionPanelStyles = (theme) => ({
  accordion: {
    backgroundColor: 'transparent',
  },
})
